import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import keyHeaders from './keyHeaders'

/**
 * Expected payload for PATCH /study/reviewer endpoint
 */
export interface ICreateAccount {
  firstName: string
  lastName: string
  password: string
  registrationCode: string
}

interface ICreateAccountResponseBody extends ICreateAccount {
  email: string
}

/**
 * Expected response for PATCH /study/reviewer endpoint
 */
export interface ICreateAccountResponse extends AxiosResponse {
  data: ICreateAccountResponseBody
}

export function createAccount( data: ICreateAccount ): Promise<ICreateAccountResponse> {
  const url = `/study/reviewer`;
  return Client.patch(url, data, { ...keyHeaders(), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/createAccount.ts